import { render } from "./BotActions.vue?vue&type=template&id=7c2434e8&scoped=true"
import script from "./BotActions.vue?vue&type=script&lang=js"
export * from "./BotActions.vue?vue&type=script&lang=js"

import "./BotActions.vue?vue&type=style&index=0&id=7c2434e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2434e8"]])

export default __exports__